const local = '_PROVIDER_BASE_ORIGEM_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_GET_BASE_ORIGEM: function (callback) {
			this._httpGet('/Base_origem/get', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerBaseOrigemUpdate: function () {
			//console.log("update classificao")
			// ESTADOS
			this._GET_BASE_ORIGEM(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerBaseOrigem: function (callback) {
			//console.log("update classificao", update)

			if (!update) {
				update = true
				this._GET_BASE_ORIGEM(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_BASE_ORIGEM(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}